/* @flow */

import createTheming from './createTheming';

export { createTheming };
export type { ThemingType } from './createTheming';
